import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { FormData } from "../../state/Markups/FormData";


const updateFormData: Reducer<FormData> = (state: FormData = new FormData(), action: Action<ActionType, FormData>) => {
  switch (action.type) {
    case ActionType.MARKUPS_FORM_UPDATED:
      if (!action.data.pageNumber) {
        return { ...state, ...action.data}
      }
      return { ...state, ...action.data };
    case ActionType.MARKUPS_FORM_RESET:
      return new FormData();
    default:
      return state;
  }
};

export default updateFormData;
